import { AppContext } from "@lightspeed-invoicing/core-client/frontend"

class BillingService {

    static async loadInitialSubscription(){ 
        const res = AppContext.getApiClient().get("/accounts/billing/subscription-details") 
        return res
    }
    static async retrieveDefaultSubscriptionInformation(){
        const res = await AppContext.getApiClient().get("/accounts/billing/default-subscription-information") 
        return res
    }


}

export default BillingService


// WEBPACK FOOTER //
// ./src/state/billing/BillingService.ts